<script setup lang="ts">
import initConfig from "../CsdPublic/initConfig";
import { allBaseUrl } from "@/config/apiDomain";
import { AppConfig } from "@/utils/constant";
import { onMounted } from "vue";

import publicStore from "@/store/publicStore";

const config = {
  soft_id: AppConfig.soft_id,
  os: AppConfig.os,
  curr_ver: AppConfig.curr_ver,
  wxLoginAndPayDomain: allBaseUrl.qnwApi.url,
  qnwProjectDomain: allBaseUrl.qnwApi.url,
};

initConfig(config);

onMounted(() => {
  const store = publicStore();

  store.changeVipInfo();
});
</script>

<template>
  <router-view v-slot="{ Component }">
    <Transition name="fade">
      <component :is="Component" />
    </Transition>
  </router-view>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  user-select: none;
}

* {
  box-sizing: border-box;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
</style>
